import React from 'react';

import ReportedPostsPage from 'components/reportedPosts';
const ReportedPost = () => {
  return <ReportedPostsPage />;
};
export default ReportedPost;
